module.exports = __webpack_public_path__ + "img/poweredByIotag.6aa47ee1.png";